import React from 'react';
//import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const Congratulations = props => {
    return (
        <div>
             <Typography variant="h6" gutterBottom>
                Su Crédito ha sido aprobado, se desembolsara en los próximos minutos
            </Typography>
        </div>
    );
};

Congratulations.propTypes = {
    
};

export default Congratulations;